import {until} from 'lit-html/directives/until';
import {repeat} from 'lit-html/directives/repeat';
import '@modules/ems-collapse';
import '@modules/auth-context';
import '@modules/link-to';
import '@modules/role-toggle';
import '@modules/jobs-status';
import '@modules/profile-toggle';
import {pages, permissions, userTypes } from '@modules/constants-enumerate';
import {dashboardLabels} from '@modules/i18n-labels';

const renderTiers = (ctx, html) => {
  if (ctx.userType === userTypes.PARENT) {
    return;
  }
  let href = null;

  const tiers = Object.keys(ctx.myGroups).map((level) => {
    if (parseInt(level, 10) <= parseInt(ctx.myLevel, 10)) return '';

    href = (!href) ? '/org-group/' + ctx.myGroups[level].level + '/' : href;

    return html`
      <link-to
        class="menu-link ml-nested"
        id="org-level-${ctx.myGroups[level].level}"
        data-bi-id="nav_link_to_level_${ctx.myGroups[level].level}"
        href="/org-group/${ctx.myGroups[level].level}/"
        track-url-partial><span class="ai ai-district"></span> ${ctx.myGroups[level].label}</link-to>
    `;
  });

  if (!href) {
    const levels = [0, 1, 2]; // Classes, Teachers, Students

    levels.forEach((value, key) => {
      if (ctx.menuItems[value]?.show) {
        href = ctx.menuItems[value]?.href;
        return;
      }
    });
  }

  const manageHtml = html`
    <link-to class="menu-link" href="${href}" data-bi-id="nav_link_to_manage">
      <span class="ai ai-manage"></span>
      ${until(ctx.__('<tt-e9JJYVwv>', 'Manage'))}
    </link-to>`;

  return html`${manageHtml} ${tiers}`;
};

const getGroupName = (ctx, html) => {
  if (ctx.userType === userTypes.PARENT) {
    return;
  }
  return html`
    <h4 class="h4 menu-heading m-0">
      <span class="ai ai-organization"></span>
      ${ctx.groupName}
    </h4>
  `;
};

const getDashboardLink = (ctx, html) => {
  let link = pages.DASHBOARD;
  let icon = html`<span class="ai ai-dashboard"></span>`;
  if (ctx.userType === userTypes.PARENT) {
    link = pages.PARENT_DASHBOARD;
    icon = '';

    if (!ctx.showDashboardLinkForParent) {
      return;
    }
  }

  const dashboardLabel = until(ctx.__('<tt-hTHJjnGL>', 'Dashboard'));

  //show usage and dashboard
  if (ctx.showLanding) {
    const dashboardLink = pages.LANDING;
    const usageTracker = pages.DASHBOARD;

    return html `
      <link-to class="menu-link" id="link-to-landing" href="${dashboardLink}" data-bi-id="nav_link_to_landing" track-url>
        ${icon}
        <span>${dashboardLabel}</span>
      </link-to>
      <link-to class="menu-link ml-nested" id="link-to-dashboard" href="${usageTracker}" data-bi-id="nav_link_to_dashboard" track-url>
        ${icon}
        <span>${until(dashboardLabels.USAGE_TRACKER)}</span>
      </link-to>
    `;
  } else {
    return html`
      <link-to class="menu-link" id="link-to-dashboard" href="${link}" data-bi-id="nav_link_to_dashboard" track-url>
        ${icon}
        <span>${dashboardLabel}</span>
      </link-to>
    `;
  }
};

export default (ctx, html) => html`
<div tabindex="0" id="focus-pre"></div>
<div class="wrapper">
  ${ctx.hasMultipleProfiles ? html`<profile-toggle focusfirst tabindex="0" class="d-md-none pl-5 align-items-center"></profile-toggle>` : ``}
  <hr class="w-100 border-secondary d-md-none">
  <div class="d-md-none d-flex flex-column">
    <collapse-button role="button" focusfirst class="menu-link d-flex align-items-center" tabindex="0" controls="(main-menu-account, account-collapse)">
      <span>${until(ctx._r(ctx.__('<tt-1JKG2kqp>', 'Welcome, %r1%'), ctx.username))}</span>
      <span class="ai ai-chevron-down"></span>
    </collapse-button>
    <ems-collapse id="account-collapse" group="main-menu-account">
      <h5 class="h5 menu-heading mb-0">Switch Role</h5>
      <role-toggle class="d-block menu-label pt-0 pb-0" item-class="btn btn-block text-left pl-0"></role-toggle>
      <hr>
      <link-to class="menu-link btn btn-block text-left m-0" href="${pages.MY_PROFILE}">${until(ctx.__('<tt-tQ4mMIvZ>', 'Edit Profile'))}</link-to>
      <auth-context class="d-block" show-on-auth .permissions="${[permissions.USER_EDIT]}">
        <link-to class="menu-link btn btn-block text-left m-0" href="${pages.ADMIN_SEARCH}">${until(ctx.__('<tt-2Oc8J13N>', 'Manage Administrators'))}</link-to>
      </auth-context>
      <button class="menu-link btn btn-block text-left m-0" @click=${ctx.logout}>${until(ctx.__('<tt-CQ15MNY9>', 'Log out'))}</button>
    </ems-collapse>
    <hr class="w-100 border-secondary">
  </div>
  ${getGroupName(ctx, html)}
  <nav>
    ${getDashboardLink(ctx, html)}
    ${renderTiers(ctx, html)}
    ${repeat(ctx.menuItems, (menuItem) => menuItem, (menuItem) => {
      if (menuItem.show) {
        return html`
          <link-to class="menu-link ${menuItem.linkClass}" href="${menuItem.href}"
            ?track-url-partial="${menuItem.trackUrlPartial}"
            ?track-url="${menuItem.trackUrl}"
            data-bi-id="nav_${menuItem.biId}"
            id="${menuItem.linkId}">
            ${menuItem.warning ? html`<img src="${require('@assets/images/warning-sign.webp')}"/>` : ``}
            <span class="${menuItem.icon}"></span> <span>${menuItem.label}</span>
          </link-to>
        `;
      }
    })}
  </nav>
  <jobs-status class="p-1" tabindex="0" focuslast></jobs-status>
  <template class="d-none active"></template>
  <div tabindex="0" id="focus-post"></div>
</div>
`;
